import { youthSummarySchema, type YouthSummary } from '@growup/arena-shared';
import { Autocomplete } from '@growup/ui';
import { useState } from 'react';
import { z } from 'zod';

import { getJson } from '../api';

/** Youths of this arena whose login contains `q`. Monitors only ever see logins (RN-A16). */
export function searchYouths(arenaId: string, q: string): Promise<YouthSummary[]> {
  return getJson(
    `/api/arena/arenas/${arenaId}/youths?q=${encodeURIComponent(q)}`,
    z.array(youthSummarySchema),
  );
}

/** One suggestion: the login, and a warning when the youth cannot unlock a PC. */
export function YouthSuggestion({ youth }: { youth: YouthSummary }) {
  return (
    <>
      {youth.login}
      {!youth.canUnlock ? (
        <span className="ml-2 text-caption text-gu-warning">sem acesso</span>
      ) : null}
    </>
  );
}

/** Pick a youth by login; the field clears after each pick. */
export function YouthPicker({
  arenaId,
  label,
  onPick,
}: {
  arenaId: string;
  label: string;
  onPick: (youth: YouthSummary) => void;
}) {
  const [query, setQuery] = useState('');
  return (
    <Autocomplete
      aria-label={label}
      placeholder={`${label}: procurar login`}
      value={query}
      onChange={setQuery}
      search={(q) => searchYouths(arenaId, q)}
      getKey={(y) => y.accountId}
      renderItem={(y) => <YouthSuggestion youth={y} />}
      onSelect={onPick}
      clearOnSelect
    />
  );
}
